import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';
import { UserPreferences } from '@scenario/models/user-preferences.model';
import {
  savedUserPreferencesFailure,
  savedUserPreferencesSuccess,
} from '@store/scenario/user-preferences/user-preferences-slice';

export const saveUserPreferencesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('userPreferences/saveUserPreferences'),
    concatMap((action: PayloadAction<UserPreferences>) =>
      from(dependencies.userPreferencesGateway.save(action.payload)).pipe(
        map(() => savedUserPreferencesSuccess(action.payload)),
        catchError(() => of(savedUserPreferencesFailure('Fail to save user preferences'))),
      ),
    ),
  );
